var _defs, _g, _path, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 26"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "new-tag_svg__a",
    width: 63,
    height: 48,
    x: -11,
    y: -11,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceGraphic",
    result: "FeOffset1025Out"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "FeOffset1025Out",
    result: "FeGaussianBlur1026Out",
    stdDeviation: "2.4 2.4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "new-tag_svg__b",
    width: 2,
    height: 2,
    x: -1,
    y: -1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h31v16H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5a3 3 0 013-3h25a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#new-tag_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M5 8.5a3 3 0 013-3h25a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3z",
    mask: "url(\"#b\")"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3273fa",
    d: "M5 8.5a3 3 0 013-3h25a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3273fa",
    d: "M5 8.5a3 3 0 013-3h25a3 3 0 013 3v9a3 3 0 01-3 3H8a3 3 0 01-3-3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.16 16.5a.188.188 0 01-.11-.035.14.14 0 01-.06-.095l-1.98-6.7a.111.111 0 01-.01-.05c0-.08.047-.12.14-.12h1.7c.087 0 .14.043.16.13l.85 3.26c.007.02.017.032.03.035.013.003.023-.008.03-.035l.67-3.26c.02-.087.077-.13.17-.13h1.46c.087 0 .14.043.16.13l.75 3.26c.007.027.017.04.03.04.013 0 .023-.013.03-.04l.75-3.26c.02-.087.073-.13.16-.13h1.71c.053 0 .092.015.115.045.023.03.028.072.015.125l-1.78 6.7c-.02.087-.073.13-.16.13h-1.6c-.093 0-.15-.043-.17-.13l-.72-3.44c-.007-.02-.017-.03-.03-.03-.013 0-.023.01-.03.03l-.63 3.43c-.02.093-.073.14-.16.14zm-7.83 0a.149.149 0 01-.11-.04.149.149 0 01-.04-.11v-6.7c0-.047.013-.083.04-.11a.149.149 0 01.11-.04h4.77c.047 0 .083.013.11.04.027.027.04.063.04.11v1.31a.149.149 0 01-.04.11.149.149 0 01-.11.04h-2.99c-.033 0-.05.017-.05.05v.94c0 .033.017.05.05.05h1.85c.047 0 .083.013.11.04.027.027.04.063.04.11v1.3a.149.149 0 01-.04.11.149.149 0 01-.11.04h-1.85c-.033 0-.05.017-.05.05v1.04c0 .033.017.05.05.05h2.99c.047 0 .083.013.11.04.027.027.04.063.04.11v1.31a.149.149 0 01-.04.11.149.149 0 01-.11.04zm-7.18 0a.149.149 0 01-.11-.04.149.149 0 01-.04-.11v-6.7c0-.047.013-.083.04-.11a.149.149 0 01.11-.04h1.51c.08 0 .14.033.18.1l2.03 3.4c.013.02.027.028.04.025.013-.003.02-.018.02-.045l-.01-3.33c0-.047.013-.083.04-.11a.149.149 0 01.11-.04h1.58c.047 0 .083.013.11.04.027.027.04.063.04.11v6.7a.149.149 0 01-.04.11.149.149 0 01-.11.04h-1.51a.196.196 0 01-.18-.1L11.92 13c-.013-.02-.027-.028-.04-.025-.013.003-.02.018-.02.045l.02 3.33a.149.149 0 01-.04.11.149.149 0 01-.11.04z"
  }))));
}
export default __webpack_public_path__ + "static/svg/new-tag.svg";
export { SvgNewTag as ReactComponent };